/**
 * Data Attributes Types
 * PROJ-042 Phase 2 - Data Attributes Frontend
 */

import type { DataClassification } from './data-classification';

export type DataAttributeCategory =
  | 'PII'
  | 'SENSITIVE'
  | 'FINANCIAL'
  | 'HEALTH'
  | 'BEHAVIORAL'
  | 'BIOMETRIC'
  | 'EMPLOYMENT'
  | 'AUTHENTICATION';

export interface DataAttribute {
  code: string;
  name: string;
  description?: string;
  category: DataAttributeCategory;
  icon?: string;
  defaultClassificationCode?: string;
  defaultClassification?: {
    code: string;
    name: string;
    level: string;
    colorCode: string;
  };
  isSystem: boolean;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateDataAttributePayload {
  code: string;
  name: string;
  description?: string;
  category: DataAttributeCategory;
  icon?: string;
  defaultClassificationCode?: string;
}

export interface UpdateDataAttributePayload {
  name?: string;
  description?: string;
  category?: DataAttributeCategory;
  icon?: string;
  defaultClassificationCode?: string;
}

// For workflow node associations
export interface NodeDataAttribute {
  dataAttributeCode: string;
  dataAttribute: DataAttribute;
  classificationCode: string;
  classification: {
    code: string;
    name: string;
    level: string;
    colorCode: string;
  };
}

// Display helpers
export const DATA_ATTRIBUTE_CATEGORIES: Array<{
  value: DataAttributeCategory;
  label: string;
  description: string;
}> = [
  {
    value: 'PII',
    label: 'Información Personal Identificable',
    description: 'Datos que identifican directamente a una persona',
  },
  {
    value: 'SENSITIVE',
    label: 'Datos Sensibles',
    description: 'Información que requiere protección especial',
  },
  {
    value: 'FINANCIAL',
    label: 'Información Financiera',
    description: 'Datos relacionados con transacciones y finanzas',
  },
  {
    value: 'HEALTH',
    label: 'Información de Salud',
    description: 'Datos médicos y de salud',
  },
  {
    value: 'BEHAVIORAL',
    label: 'Datos de Comportamiento',
    description: 'Información sobre comportamiento y preferencias',
  },
  {
    value: 'BIOMETRIC',
    label: 'Datos Biométricos',
    description: 'Información biométrica única',
  },
  {
    value: 'EMPLOYMENT',
    label: 'Información Laboral',
    description: 'Datos relacionados con empleo',
  },
  {
    value: 'AUTHENTICATION',
    label: 'Autenticación',
    description: 'Credenciales y datos de autenticación',
  },
];

export function formatDataAttributeCategory(category: DataAttributeCategory): string {
  const item = DATA_ATTRIBUTE_CATEGORIES.find((c) => c.value === category);
  return item?.label || category;
}
